import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { headerType } from '@config/customTypes.config';

@Injectable({
    providedIn: 'root',
})
export class HeadersService {
    constructor(public _http: HttpClient) {}

    getHeaders() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            }),
        };
    }

    /**
     * Returns httpOptions - headers without content-type
     */
    getHeaderWOCT(): any {
        return {
            headers: new HttpHeaders({
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            }),
        };
    }

    getHeaderBlob(): any {
        return {
            headers: new HttpHeaders({
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            }),
            responseType: 'blob',
        };
    }

    getHeaderByType(type: headerType): any {
        switch (type) {
            case 'common':
                return this.getHeaders();
            case 'woct':
                return this.getHeaderWOCT();
            case 'blob':
                return this.getHeaderBlob();
            default:
                return this.getHeaders();
        }
    }
}
